<template lang="pug">
.appComponent(:class="appClasses")
  app-modal
  .header
    app-header
  .content
    app-content
  ui-observer(@observe="observe")
  .footer()
    app-footer
    template(v-if="isDesktop")
      basket-link-desktop(
        v-if="showButtonLink"
        :class="{'stop': addBasketLinkClass}"
      )
    template(v-else)
      basket-link(v-if="showButtonLink")
</template>

<script>
import ps from '@/payment-service'
import { useRoute, useRouter } from 'vue-router'
import { computed, inject, ref, onMounted, onUnmounted, watch } from 'vue'
import AppHeader from '@/components/_layout/Header/Header'
import AppContent from '@/components/_layout/Content/Content'
import AppFooter from '@/components/_layout/Footer/Footer'
import AppModal from '@/components/_layout/AppModal/AppModal'
import AppTutorial from '@/components/AppTutorial/AppTutorial'
import DemoModal from '@/components/Demo/DemoModal'
import BasketLink from '@/modules/Basket/components/BasketLink'
import BasketLinkDesktop from '@/modules/Basket/components/BasketLinkDesktop'
import { LS_BASKET_ID_KEY } from '@/modules/Basket/config'
import store from './store'
export default {
  components: {
    AppHeader,
    AppContent,
    AppFooter,
    AppModal,
    BasketLink,
    BasketLinkDesktop
  },
  inject: ['store'],
  setup () {
    const store = inject('store')
    const route = useRoute()
    const router = useRouter()
    const routeName = computed(() => route.name)
    const appClasses = computed(() => ({
      _player: routeName.value === 'Lesson',
      _homepage: routeName.value === 'Home'
    }))

    store.user.$on('requestDemo-success', () => {
      if (routeName.value !== 'Home') {
        if (!store.user.profile.hasSubscriptions && (store.user.profile.subscription.isNone || store.user.profile.subscription.isOver)) {
          store.modalQueue.push({
            key: 'demo',
            component: DemoModal
          })
        } else if (store.user.profile.showTutorial) {
          store.modalQueue.push({
            key: 'apptutorial',
            component: AppTutorial
          })
        }
      }
    })

    store.user.$on('logout-success', () => router.push({ name: 'Home' }))

    const addBasketLinkClass = ref(false)
    const observe = event => (addBasketLinkClass.value = event)

    const showButtonLink = computed(() => !['Basket', 'Lesson'].includes(routeName.value) && store.basket.data?.itemsCount)

    watch(() => store.user.profile, (val) => ps.updateUserId(val ? val.uuid : null))

    // Вызов корзины
    store.basket.requestBasket()

    const WW = ref()
    const isDesktop = computed(() => {
      if (WW.value > 770) return true
      else return false
    })
    const setWW = () => (WW.value = window.innerWidth)
    onMounted(() => {
      WW.value = window.innerWidth
      window.addEventListener('resize', setWW)
    })
    onUnmounted(() => window.removeEventListener('resize', setWW))

    return { appClasses, observe, route, addBasketLinkClass, showButtonLink, isDesktop }
  },
  created () {
    this.store.user.$on('requestprofile-success', () => {
      ps.updateUserId(this.store.user.profile.uuid)
      store.basket.requestBasket()
    })

    this.store.user.$on('requestprofile-error', () => {
      ps.updateUserId(null)
      store.basket.requestBasket()
    })

    this.store.user.$on('logout-success', () => {
      this.$router.push({ name: 'Home' })
      localStorage.removeItem(LS_BASKET_ID_KEY)
      ps.updateUserId(null)
      store.basket.requestBasket()
    })
  }
}
</script>

<style lang="sass" scoped>
.appComponent
  min-height: 100vh
  display: flex
  flex-direction: column
  overflow-y: auto
  overflow-x: hidden
  scroll-behavior: smooth

  &._player
    min-height: 100%

  > .header
    background-color: $cWhite

  > .content
    flex: 1
    display: flex
    flex-direction: column

  > .footer
    margin-top: auto
    background-color: $cWhite
    position: relative

  &._homepage
    background: $cWhite
    > .header
      width: 100%
      position: fixed
      left: 0
      top: 5*$u
      padding: 0 $appSidePaddingDesktop
      z-index: $zIndexAppHeader
      background: transparent
      @media (max-width: $XXLWidth)
        background: $cWhite
        top: 0
        padding: 0
</style>
